import React, { Component } from 'react'
import { inject, observer } from 'mobx-react'
import PropTypes from 'prop-types'

import Button from '@components/Button'

class ScreeningQuestions extends Component {
  static propTypes = {
    screeningQuestions: PropTypes.object,
    screening: PropTypes.object,
    modalStore: PropTypes.object
  }

  render () {
    const { screeningQuestions, screening, modalStore } = this.props
    return (
      <div className='expert-form screening-questions'>
        <h1 className='client-view__expert-profile__title m-t-sm'>
          Expert's Answers to Screening Questionnaire
        </h1>
        <div className='hr-separator hr-separator--form' />
        {screeningQuestions.length ? (
          screeningQuestions.map((q, i) => (
            <div key={q.id}>
              {screeningQuestions.length > 1 && i > 0 && (
                <div className='hr-separator hr-separator--form' />
              )}
              <div className='expert-form__input-group'>
                <b dangerouslySetInnerHTML={{ __html: q.question }} />
              </div>
              {screeningQuestions.length === 1 && (
                <div className='hr-separator hr-separator--form' />
              )}
              <div dangerouslySetInnerHTML={{ __html: q.answer }} />
            </div>
          ))
        ) : (
          <div>--</div>
        )}
        <div className='hr-separator hr-separator--form' />
        <h1 className='client-view__expert-profile__title m-t-lg m-b-0'>
          Screening Information (Client Facing)
        </h1>
        <div className='hr-separator hr-separator--form' />
        {screening ? (
          <div className='story'>
            <div
              className='text'
              dangerouslySetInnerHTML={{ __html: screening }}
            />
          </div>
        ) : (
          <div>--</div>
        )}
        <div className='hr-separator hr-separator--form' />
        <Button secondary onClick={modalStore.close}>
          Close
        </Button>
      </div>
    )
  }
}

ScreeningQuestions.defaultProps = {
  hideButtons: true,
  showCloseIcon: true
}

export default inject('modalStore')(observer(ScreeningQuestions))
